<template>
  <div class="deviceno">
    <div class="devicenobox">
      <div class="devicenogutter">
        <div class="devicenocell">
          <!-- 添加设备 -->
          <div class="boximg"></div>
          <div class="operate">
            <span class="tip">{{ $t('device.deviceNo') }}</span>
            <button type="button" @click="dialogDataloggerVisible = true">
              <i class="iconfont icon-tianjia1"></i>
              {{ $t('datalogger.add') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--创建数采器-->
    <datalogger-dialog
      :visible.sync="dialogDataloggerVisible"
      v-if="dialogDataloggerVisible"
      @submitSucAdd="handleCreateSuc"
      @submitFailAdd="handleCreateFail"
    ></datalogger-dialog>
  </div>
</template>
<script>
import dataloggerDialog from "@/components/dialognew/dataloggernew";
export default {
  components: {
    dataloggerDialog
  },
  data() {
    return {
      // 创建数采器弹窗
      dialogDataloggerVisible: false,
      // 查询该数采器下有无设备
      dataloggeDeviceList: []
    };
  },
  methods: {
    // 创建数采器成功回调
    // handleCreateSuc() {
    //   // this.$message.success(this.$t("datalogger.addSuc"));
    // 	console.log('空页跳转新增数采器成功回调');
    //   this.$router.push({path:'/generalNew/setting/datalogger'});
    //   // 通知数采器列表更新
    //   this.$store.state.event.updateDataloggerList = true;
    // },
    // 添加数采器成功回调
    handleCreateSuc(pn) {
      // console.log('空白页=>添加成功回调(带pn)', pn);
      // console.log('空页跳转新增数采器成功回调');
      // this.$message.success(this.$t("datalogger.addSuc"));
      // this.dataloggerAddFailMsg = val;
      // this.dataloggerAddSucVisible = true;
      // this.$emit("submitSucAdd");
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      // this.getDataloggerList();

      // 查询该数采器下有无设备
      this.getDataloggerDevice(pn);

      // this.$router.push({
      // 	path:'/generalNew/setting/datalogger',
      // 	query: {
      // 		'tool' : {
      // 			'notice': 'Suc'
      // 		}
      // 	}
      // });
    },
    // 添加数采器失败回调
    handleCreateFail(val, name) {
      // console.log('空白页=>添加失败回调(带报错信息)', val);
      // this.dataloggerTipMsg = val;
      // this.dataloggerAddFailVisible = true;
      // this.$emit("submitFailAdd", val);
      this.$router.push({
        path: "/generalNew/setting/datalogger",
        query: {
          tool: {
            notice: "Fail",
            noticeVal: val,
            noticeValName: name
          }
        }
      });
    },
    // 查看数采器对应设备
    getDataloggerDevice(pn) {
      let param = {
        pn: pn,
        devtype: 2304,
        page: 1,
        pageSize: 50
      };
      // this.loadingPreviewDevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        // console.log('空白页=>查询该数采器下设备情况');
        if (res.code === 0) {
          // console.log('空白页=>查询成功');
          this.dataloggeDeviceList = this.Fnreturndev(res);
          let deviceInfo = this.dataloggeDeviceList[0] || {};
          if (this.dataloggeDeviceList.length > 0) {
            // console.log('空白页=>该数采器下有设备');
            // 保存设备信息 (去除该处)
            // this.$store.commit("saveDeviceInfo", {
            // 	pn: deviceInfo.pn,
            //   sn: deviceInfo.sn,
            //   devaddr: deviceInfo.devaddr,
            //   devcode: deviceInfo.devcode,
            //   status: deviceInfo.status,
            //   devalias: deviceInfo.devalias,
            //   // pid: deviceInfo.pid,
            //   focus: deviceInfo.focus
            // });
            // 跳转我的设备
            setTimeout(() => {
              this.$router.push({
                path: "/generalNew/home",
                query: {
                  tool: {
                    notice: "Suc"
                  }
                }
              });
            }, 0);
          } else {
            // console.log('空白页=>该数采器下无设备');
            // 跳转数采器管理
            this.$router.push({
              path: "/generalNew/setting/datalogger",
              query: {
                tool: {
                  notice: "Suc"
                }
              }
            });
          }
        } else {
          // console.log('空白页=>查询失败');
          this.dataloggeDeviceList = [];
          // 跳转数采器管理
          this.$router.push({
            path: "/generalNew/setting/datalogger",
            query: {
              tool: {
                notice: "Suc"
              }
            }
          });
        }
        // this.loadingPreviewDevice = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.deviceno {
  width: 100%;
  height: 100%;
  background: rgba(45, 63, 75, 1);
  display: flex;
  flex-direction: column;

  .devicenobox {
    flex: 1;
    background: rgba(45, 63, 75, 1);
    padding: 30px 20px;

    .devicenogutter {
      width: 100%;
      height: 100%;
      background: rgba(34, 45, 53, 1);
      box-shadow: 2px 2px 11px rgba(34, 45, 53, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .devicenocell {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      width: 1090px;
      height: 483px;
      background: url(../../../assets/img/general/Bgi_Deviceno.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      background-color: rgba(34, 45, 53, 1);
      padding-top: 100px;
    }

    .boximg {
      width: 132px;
      height: 132px;
      background: url(../../../assets/img/general/Box_Deviceno.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      margin-right: 26px;
    }

    .operate {
      padding-top: 24px;

      .tip {
        display: block;
        align-items: center;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        margin-bottom: 20px;
      }
    }

    // 添加按钮
    button {
      display: inline-block;
      padding: 14px 46px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 16px;
      cursor: pointer;
      box-shadow: 0px 4px 16px rgba(48, 208, 150, 0.29),
        0px 4px 15px rgba(255, 255, 255, 0.25) inset;

      i {
        font-weight: bold;
      }
    }
  }

  .btm {
    width: 100%;
    height: 20px;
    background: rgba(45, 63, 75, 1);
  }
}
</style>